<template>
  <div id="app">
    <login-component 
        v-if="isExpired" 
        :msj="2"
        @login="login = $event"
        >
      </login-component>
      <router-view></router-view>
  </div>
</template>
<script>
  import mapHelper from '@/store/modules/common/map-helper'
  import loginComponent from '@/components/loginComponent/PxLogin.vue' 
  export default {
      name:'App',
      components:{loginComponent},
      data(){
          return{
            title: process.env.VUE_APP_TITLE,
          }
      },
      computed:{
        isExpired(){
          return this.$store.getters[mapHelper.mapmod.SIAHE_AUTH+mapHelper.mapfn.getExpired]
        }
      },
      created(){
        let userSession = { 
          // login : this.$session.exists() ? this.$session.get("login") : null,
          token : this.$session.exists() ? this.$session.get("token") : null,
          refreshToken : this.$session.exists() ? this.$session.get("refreshToken") : null,
        };
        this.$store.dispatch(mapHelper.mapmod.SIAHE_AUTH+mapHelper.mapfn.setAuth, userSession);
      },
      mounted(){
        document.title = this.title;
      }
  }
</script>
<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */

/* nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
